// extracted by mini-css-extract-plugin
module.exports = {"background":"ConfirmModal_background__1kJJc","modal":"ConfirmModal_modal__2APML","question":"ConfirmModal_question__1zNWZ","actions":"ConfirmModal_actions__xWQWQ"};